<template>
  <div id="app">
      <!-- 路由占位符，匹配到的组件都会渲染到router-view中展示 -->
      <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',

}
</script>

<style lang="less" scoped>
    #app {

    }
</style>



// WEBPACK FOOTER //
// src/App.vue